module.exports = __webpack_public_path__ + "img/quicklink-tiles-mazda.e21eb7f3.png";